<!-- eslint-disable max-len -->
<template>
  <div class="section-container m--20">
    <b-form-group>
      <label>Name</label>
      <j-input
        v-model="dataset_data.name"
        :disabled="true"/>
    </b-form-group>
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies, no-nested-ternary, max-len, no-console, no-unused-vars */
import { mapState } from 'vuex';

export default {
  // eslint-disable-next-line
  name: 'jDatasetGeneral',
  data() {
    return {
    };
  },
  computed: {
    ...mapState('jStoreJoana', ['dataset_data']),
  },
  watch: {
  },
  created() {
  },
  methods: {
  },
};
</script>



// WEBPACK FOOTER //
// src/views/joanadb/dataset/jDatasetGeneral.vue